import { render, staticRenderFns } from "./sidebarLogo.vue?vue&type=template&id=70f5b1ca&scoped=true"
import script from "./sidebarLogo.vue?vue&type=script&lang=ts"
export * from "./sidebarLogo.vue?vue&type=script&lang=ts"
import style0 from "./sidebarLogo.vue?vue&type=style&index=0&id=70f5b1ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f5b1ca",
  null
  
)

export default component.exports